import {useDebugValue} from 'react';

import {
    useCookies,
    useSystem,
    useMedia,
    useAbacus,
    useEdap,
    useSearch,
    useForm,
    useDestination,
    useDestinationSummary,
    useDates,
    useGuests,
    useSubmit,
    useSubmitSummary,
    useSubmitDetails,
    useDetailsModal
} from './';

function useSearchFormContext(props) {
    const cookies = useCookies();

    const system = useSystem(props);
    const media = useMedia(props);

    const abacus = useAbacus(props);

    const edap = useEdap(props);

    const search = useSearch(props);

    const form = useForm(props);

    const destination = useDestination(props, cookies, system, abacus);
    const destinationSummary = useDestinationSummary(props);

    const dates = useDates(props, cookies, system, abacus);
    const guests = useGuests(props, cookies, system, abacus);

    const submit = useSubmit(props);
    const submitSummary = useSubmitSummary(props);
    const submitDetails = useSubmitDetails(props);

    const detailsModal = useDetailsModal(props);

    const result = {
        system,
        media,
        abacus,
        edap,
        search,
        form,
        destination,
        destinationSummary,
        dates,
        guests,
        submit,
        submitSummary,
        submitDetails,
        detailsModal
    };

    useDebugValue(result);

    return result;
}

export {useSearchFormContext};
